<div class="multi-step-form" [hidden]="isLoading">
  <div class="multi-step-form-sidebar">
    <ng-content select="[sidebar]"></ng-content>
  </div>
  <div class="multi-step-form-step">
    <div class="multi-step-form-step-content">
      <ng-container
        *ngFor="let step of wizardSteps; let i = index; trackBy: trackByFn"
      >
        <form
          nz-form
          [nzLayout]="'vertical'"
          [formGroup]="step.stepForm"
          *ngIf="i === activeStepIndex || masterForm.length === 1"
          #stepForm
        >
          <ng-content></ng-content>
        </form>
        <ng-content select="[summary]"></ng-content>
      </ng-container>
    </div>
    <div class="multi-step-form-step-footer">
      <ng-container *ngIf="activeStepIndex === 0; else prevButtonTpl">
        <button nz-button nzType="default" (click)="cancel()">
          {{ "BUTTON.CANCEL" | translate }}
        </button>
      </ng-container>
      <ng-template #prevButtonTpl>
        <button nz-button nzType="default" (click)="prev()">
          {{ "BUTTON.PREVIOUS" | translate }}
        </button>
      </ng-template>
      <ng-container
        *ngIf="activeStepIndex < wizardSteps.length - 1; else doneButtonTpl"
      >
        <button
          nz-button
          nzType="primary"
          [disabled]="activeStepForm?.invalid"
          (click)="next()"
        >
          {{ "BUTTON.NEXT" | translate }}
        </button>
      </ng-container>
      <ng-template #doneButtonTpl>
        <button nz-button nzType="primary" (click)="submitForm()" [disabled]="!isMasterFormValid">
          {{ "BUTTON.DONE" | translate }}
        </button>
      </ng-template>
    </div>
  </div>
</div>

<div class="multi-step-form loading" [hidden]="!isLoading">
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
</div>
